import React, { Component } from 'react';
import './index.scss';
import FNBComponent from '../../components/FnB';
import BookingFlow from '../../components/BookingFlow';
import Header from '../../components/Header';
import * as API from '../../configuration/apiconfig';
import queryString from 'query-string';
import { showAlert } from '../../components/showAlert';
class FNB extends Component {
  constructor(props) {
    const parsedQueryString = queryString.parse(window.location.search);
    super(props);
    this.state = {
      showTimer: false,
      cinemaId: parsedQueryString.cinemaid,
      orderId: parsedQueryString.orderid,
      bookingId: parsedQueryString.bookingid,
      fnbData: [],
      sessionId: parsedQueryString.sessionid,
      voucherFnbData: [],
      disableVoucherSection: window.constant.ENABLE_VOUCHERS == 'true' ? true : false,
    };
  }

  componentDidMount = async () => {
    console.log('FNB(page) > componentDidMount()');
    window.winvar = this;
    await this.getFnbData(this.state.cinemaId, this.state.sessionId);
    await this.getVoucherFnbData(this.state.cinemaId, this.state.sessionId);
    if (localStorage.getItem('orderType') === 'ticketing') {
      //ticketing flow
      this.setState({
        showTimer: true,
      });
    } else {
      //fnb flow
      let orderDetails = JSON.parse(localStorage.getItem('orderId'));
      if (orderDetails) {
        if (orderDetails.expiry < Date.now()) {
          orderDetails = null;
        } else {
          this.setState({
            showTimer: true,
          });
        }
      }
    }
  };

  AbortTransactionResponse = response => {
    // This is dot net function
    console.log(response, 'Swipe card abort response--F&B page');
  };

  GiftCardSwipeResponse = response => {
    // This is dot net function
    console.log(response, 'GiftCardSwipeResponse--F&B page');
  };

  getFnbData = async (cinemaId, sessionId) => {
    this.setState({
      dataLoading: true,
    });

    var setFnbURL = '';
    let orderType = localStorage.getItem('orderType');
    if (orderType == 'ticketing') {
      if (cinemaId && sessionId) {
        // Ticketing flow onload
        setFnbURL = `/cms/v2/fnbtabs?cinemaid=${cinemaId}&sessionid=${sessionId}`;
      } else {
        // Ticketing flow > fnbtabs return empty response(onload)
        setFnbURL = `/cms/v2/fnbtabs?cinemaid=${cinemaId}`;
      }
    } else {
      setFnbURL = `/cms/v2/fnbtabs?cinemaid=${cinemaId}`;
    }

    API.callEndpoint('GET', 'Bearer', `${setFnbURL}`)
      .then(res => {
        this.setState(
          {
            fnbData: res.data,
          },
          () => {
            if (this.state.fnbData.length == 0 && orderType == 'ticketing') {
              showAlert({
                html: `
                <p>Food and Drink orders made now are for immediate collection. If you would like your Food and Drink items closer to the time of your show, please skip this step and order your Food and Drink later.</p>`,
                iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
                showCancelButton: false,
                cancelButtonText: 'CANCEL',
                showConfirmButton: true,
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                iconClasses: 'borderless',
                popupClasses: 'common-error-alert',
                onConfirm: () => {
                  this.getFnbData(this.state.cinemaId, null);
                },
                onCancel: () => {},
              });
            }
          }
        );
      })
      .catch(err => {
        showAlert({
          html: `<p>Sorry<span>${err.error}</span></p>`,
          iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
          showCancelButton: false,
          cancelButtonText: 'CANCEL',
          showConfirmButton: true,
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          iconClasses: 'borderless',
          popupClasses: 'common-error-alert',
          onConfirm: () => {
            // this.getFnbData(this.state.cinemaId, null);
          },
          onCancel: () => {},
        });
      })
      .finally(() => {
        this.setState({ dataLoading: false });
      });
  };

  getVoucherFnbData = async (cinemaId, sessionId) => {
    if (window.constant.ENABLE_VOUCHERS == 'false') return;
    var dataObj = {};
    dataObj.cinemaid = cinemaId;
    var vouchersData = JSON.parse(localStorage.getItem('vouchersScanned'));
    dataObj.vouchers = [];
    if (vouchersData != null && vouchersData.length) {
      vouchersData.map(voucher => {
        // // // // // if (voucher.dealId != "" && voucher.dealId != null) {
        if (voucher.type != 'ticket') {
          var voucherObj = {};
          voucherObj.code = voucher.vouchercode;
          voucherObj.dealId = voucher.dealId;
          voucherObj.type = voucher.type;
          dataObj.vouchers.push(voucherObj);
        }
      });
    }
    console.log('dataObj.vouchers.length: ', dataObj.vouchers.length);
    if (dataObj.vouchers.length <= 0) {
      this.setState(
        {
          disableVoucherSection: false,
        },
        () => {
          console.log('getVoucherFnbData() > No FNB Vouchers.');
        }
      );
      return;
    }

    API.callEndpoint('POST', 'Bearer', '/order/v2/vouchers/fnbs', dataObj)
      .then(response => {
        this.setState(
          {
            voucherFnbData: response.data,
            disableVoucherSection: response.data.length > 0 ? true : false,
          },
          () => {
            console.log('getVoucherFnbData() > this.state.voucherFnbData: ', this.state.voucherFnbData);
            console.log('getVoucherFnbData() > this.state.disableVoucherSection: ', this.state.disableVoucherSection);
          }
        );
      })
      .catch(err => {
        showAlert({
          html: `<p>Sorry<span>${err.error}</span></p>`,
          iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
          showCancelButton: false,
          cancelButtonText: 'CANCEL',
          showConfirmButton: true,
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          iconClasses: 'borderless',
          popupClasses: 'common-error-alert',
          onConfirm: () => {
            // this.getFnbData(this.state.cinemaId, null);
          },
          onCancel: () => {},
        });
      });
  };

  render() {
    return (
      <div className="fnb-page">
        <Header logo={true} homeIcon={false} timer={this.state.showTimer} />
        <section className="booking-flow-sec">
          <BookingFlow currentStep="2" />
        </section>
        <FNBComponent
          showHeader={true}
          showFooter={true}
          showCategoriesSelection={true}
          updateOrder={false}
          horizontal={false}
          fnbData={this.state.fnbData}
          voucherFnbData={this.state.voucherFnbData}
          disableVoucherSection={this.state.disableVoucherSection}
        ></FNBComponent>
      </div>
    );
  }
}

export default FNB;
